import React, { useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import SidebarContainer from "../Sidebar";
import HeaderContainer from "../Header";
import { useTranslation } from "react-i18next";
import ChangeLanguage from "components/ChangeLanguage";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    height: "100vh",
    overflow: "hidden",
    fontFamily: "'Be Vietnam Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  sidebar: {
    flexShrink: 0,
    position: "sticky",
    top: 0,
    height: "100vh",
    zIndex: 90,
    transition: "width 0.2s ease",
  },
  contentRight: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#F9FAFB",
    height: "100vh",
    overflowY: "auto",
  },
  content: {
    flex: 1,
    padding: "0 15px",
    paddingBottom: 24,
    marginTop: 76,
  },

  // ── PAGE FOOTER — V3 design (bombot-customers-v3_2026-07-22.html) ──────────
  // position: sticky; bottom: 0 — luôn cố định dưới vùng scroll của contentRight
  footer: {
    position: "sticky",
    bottom: 0,
    zIndex: 89,
    borderTop: "1px solid #E5E7EB",
    background: "#ffffff",
    padding: "12px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
    marginTop: "auto",
    flexShrink: 0,
  },

  // Left: "© 2026 @Bombot.vn"
  footerCopy: {
    fontSize: 12,
    color: "#6B7280",
    whiteSpace: "nowrap",
    "& a": {
      color: "#16A34A",
      fontWeight: 600,
      textDecoration: "none",
      "&:hover": { textDecoration: "underline" },
    },
  },

  // Right: lang-switch pill + links
  footerLinks: {
    display: "flex",
    alignItems: "center",
    gap: 18,
    flexWrap: "wrap",
  },

  // Navigation links (no separator, plain text)
  footerLink: {
    fontSize: 12,
    color: "#6B7280",
    textDecoration: "none",
    whiteSpace: "nowrap",
    fontFamily: "inherit",
    transition: "color 0.12s",
    "&:hover": { color: "#16A34A" },
  },
}));

const MainLayoutView = (props) => {
  const { children } = props;
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const configPage = useMemo(() => {
    if (i18n.language?.substring(0, 2) === "kh") {
      return { page_id: "102636822160260", app_id: "4087907114572119" };
    }
    return { page_id: "103634791744953", app_id: "4087907114572119" };
  }, [i18n.language]);

  return (
    <div className={classes.root}>
      <div className={classes.sidebar}>
        <SidebarContainer />
      </div>

      <div className={classes.contentRight}>
        <HeaderContainer />
        <div className={classes.content}>{children}</div>

        {/* PAGE FOOTER — V3 */}
        <footer className={classes.footer}>
          {/* Left: copyright */}
          <div className={classes.footerCopy}>
            © 2026{" "}
            <a href="https://bombot.vn/" target="_blank" rel="noreferrer">
              @Bombot.vn
            </a>
          </div>

          {/* Right: lang-switch + nav links */}
          <div className={classes.footerLinks}>
            {/* Language switcher — pill style matching mockup */}
            <ChangeLanguage isUser={true} variant="pill" />

            <a
              className={classes.footerLink}
              href="https://bombot.vn/"
              target="_blank"
              rel="noreferrer"
            >
              {t("footer.home")}
            </a>
            <a
              className={classes.footerLink}
              href="https://partner.bombot.vn/"
              target="_blank"
              rel="noreferrer"
            >
              {t("footer.affiliate")}
            </a>
            <a
              className={classes.footerLink}
              href="https://bombot.vn/chinh-sach-dich-vu/"
              target="_blank"
              rel="noreferrer"
            >
              {t("footer.policy")}
            </a>
            <a
              className={classes.footerLink}
              href="https://bombot.vn/dieu-khoan-bao-mat"
              target="_blank"
              rel="noreferrer"
            >
              {t("footer.private_policy")}
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
};

MainLayoutView.propTypes = {};
MainLayoutView.defaultProps = {};

export default MainLayoutView;
